import React from 'react'
import ReactDom from 'react-dom'
import moment from 'moment'
import TinyScrollbar from './TinyScrollbar'

class UnitList extends React.Component {

  constructor(props) {
    super(props)

    this.handleUnitClick = this.handleUnitClick.bind(this)
    this.handleUnitEnter = this.handleUnitEnter.bind(this)
    this.handleUnitLeave = this.handleUnitLeave.bind(this)
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.units !== this.props.units
    || nextProps.displayCount !== this.props.displayCount
  }

  handleUnitClick(event) {
    if (this.props.onUnitClick) {
      event.preventDefault()
      const {units} = this.props
      let id = event.currentTarget.getAttribute('data-unit-id')
      let unitsJS = units.toJS()
      let unit = unitsJS[id]
      this.props.onUnitClick({
        unit: unit
      })
    }
  }

  handleUnitEnter(event) {
    if (this.props.onUnitOver) {
      event.preventDefault()
      const {units} = this.props
      let id = event.currentTarget.getAttribute('data-unit-id')
      let unitsJS = units.toJS()
      let unit = unitsJS[id]
      this.props.onUnitOver({
        unit: unit,
        x: null,
        y: null
      })
    }
  }

  handleUnitLeave(event) {
    if (this.props.onUnitOver) {
      this.props.onUnitOver({
        unit: null,
        x: null,
        y: null
      })
    }
  }

  render() {
    const {
      displayCount,
      units
    } = this.props

    let unitsJS = units.toJS()

    return (
      <div id="list">
        <p className="list-results">
          <span id="list-number">{ displayCount ? Object.keys(unitsJS).length : null}</span>
          <span style={{fontWeight: '300'}}> Matches</span>
        </p>
        <hr/>

        <div className="list-item-container">
          <TinyScrollbar height={ 300 }>
          {Object.keys(unitsJS).map((key, index) => {
            return <div key={'unit-list-' + unitsJS[key].id} className="list-item">
                      <a
                        href="#"
                        onClick={this.handleUnitClick}
                        onMouseEnter={this.handleUnitEnter}
                        onMouseLeave={this.handleUnitLeave}
                        data-unit-id={unitsJS[key].id}>
                        <p>
                          <span className="apt-num">Apt {unitsJS[key].unitnumber}</span> <span className="plan-type">{unitsJS[key].floorplan_name}</span><br/>
                          <span className="bedroom-count">{unitsJS[key].floorplan_bedroomcount === '0' ? 'Studio' : unitsJS[key].floorplan_bedroomcount + ' bed'}</span> / <span className="bathroom-count">{parseFloat(unitsJS[key].floorplan_bathroomcount).toString()} bath</span> / <span className="sqft">{unitsJS[key].area} sqft</span><br/>
                          <span className="price">${parseInt(unitsJS[key].price)} Available {unitsJS[key].available === '2' ? 'Now' : moment(unitsJS[key].available_date, 'YYYY-MM-DD').format('MMM Do') }</span>
                        </p>
                      </a>
                    </div>
          })}
          </TinyScrollbar>
        </div>
      </div>
    )
  }
}

UnitList.defaultProps = {
  displayCount: true,
  units: []
}

export default UnitList
